export default __webpack_public_path__ + "ede3296cd4271d2fa8d54a28d2abcc8d.svg";